/* eslint-disable indent */
import React from 'react'
import T from 'prop-types'
import Joi from 'joi'
import Button from 'components/Button'
import Editorial from 'components/Editorial'
import getGenderText from 'apps/booking/helpers/getGenderText'

import Step from '../../components/Step'

export const validator = () =>
  Joi.object({
    riskGroupB: Joi.boolean().required(),
  }).unknown(true)

// Show this step if:
// User wants to be on the waitinglist
// User is not in risk group 4
export const riskGroupBPredicate = (values) => {
  if (values?.details?.on_behalf_of?.national_id) {
    return false
  }
  return !values?.vaccinationId && values?.rejection === 'venteliste' && !values?.riskGroupA
}

export default function RiskGroupB({ changeStep, values, onChange }) {
  // Update and save answer
  const handleChange = (answer) => () => {
    onChange('riskGroupB', answer)
  }

  // Get saved answer
  const status = values?.riskGroupB

  // Handle refuse (privacy compliant)
  const handleRefuse = () => {
    onChange('riskGroupB', false)
    changeStep()
  }

  const isBookingOnBehalfOf = Boolean(values?.details?.on_behalf_of?.national_id)

  return (
    <Step
      title="Har du underliggende sykdom?"
      onSubmit={changeStep}
      submit="Gå videre"
      submitDisabled={status === undefined}
    >
      <Editorial>
        <p>
          I tillegg til listen på forrige side, er det noen andre sykdommer og tilstander som skal
          gi prioritet for vaksine.
        </p>

        <h3>Gruppe B</h3>
        <ul>
          <li>Kronisk/alvorlig leversykdom</li>
          <li>Immundempende behandling</li>
          <li>Diabetes</li>
          <li>Kronisk lungesykdom</li>
          <li>Fedme med KMI over 35</li>
          <li>Demens</li>
          <li>Kroniske hjerteog karsykdommer (med unntak av høyt blodtrykk)</li>
          <li>Hjerneslag</li>
        </ul>
      </Editorial>

      <Button inline small onClick={handleChange(true)} selected={status === true}>
        {isBookingOnBehalfOf
          ? getGenderText('Ja, %s har én eller flere av tilstandene på listen over', values)
          : 'Ja, jeg har én eller flere av tilstandene på listen over'}
      </Button>

      <Button inline small onClick={handleChange(false)} selected={status === false}>
        {isBookingOnBehalfOf
          ? getGenderText('Nei, %s har ingen av tilstandene på listen over', values)
          : 'Nei, jeg har ingen av tilstandene på listen over'}
      </Button>

      <p>
        Dersom du ikke ønsker å oppgi, kan du{' '}
        <button onClick={handleRefuse} style={{ textDecoration: 'underline' }}>
          trykke her
        </button>
        .
      </p>
    </Step>
  )
}

RiskGroupB.propTypes = {
  changeStep: T.func.isRequired,
  values: T.object.isRequired,
  onChange: T.func.isRequired,
  orgUnit: T.shape({
    id: T.string.isRequired,
    slug: T.string.isRequired,
  }).isRequired,
}
